// Generates a RFC4122 version 4 UUID.
// Uses crypto.randomUUID() when available, with a crypto.getRandomValues()
// fallback for older browsers/environments.
function uuidv4 () {
  // `crypto` resolves to window.crypto in the page and self.crypto in the
  // service worker, so a bare `crypto` reference works in both scopes.
  const cryptoObj = (typeof crypto !== 'undefined' && crypto) || null

  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID()
  }

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    cryptoObj.getRandomValues(bytes)

    // Per RFC4122 §4.4: set version and variant bits.
    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80

    const hex = []
    for (let i = 0; i < 256; i++) {
      hex.push((i + 0x100).toString(16).substr(1))
    }

    return (
      hex[bytes[0]] + hex[bytes[1]] + hex[bytes[2]] + hex[bytes[3]] + '-' +
      hex[bytes[4]] + hex[bytes[5]] + '-' +
      hex[bytes[6]] + hex[bytes[7]] + '-' +
      hex[bytes[8]] + hex[bytes[9]] + '-' +
      hex[bytes[10]] + hex[bytes[11]] + hex[bytes[12]] +
      hex[bytes[13]] + hex[bytes[14]] + hex[bytes[15]]
    )
  }

  // Last-resort fallback (non-cryptographic). Should virtually never be hit.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export { uuidv4 }
